import { Form, Input } from "antd";
import { styled } from "styled-components";
import { ISearchPayload, promptUpdate, updateSettings } from "@dataone/lib";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { GalaxyStarIcon } from "@dataone/icons";
import { useAuth } from "../../../../../../auth/contexts/auth.provider";

interface PromptMessagesProps {
  // searchApp: string;
  selectedDbId: string | undefined;
  response: Partial<ISearchPayload>;
  setResponse: React.Dispatch<React.SetStateAction<Partial<ISearchPayload>>>;
  // tableExpanded: boolean;
}

function PromptMessages({ response, setResponse }: PromptMessagesProps) {
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(-1);
  const [searchForm] = Form.useForm();

  const { setUser } = useAuth();

  const { mutate: promptSettingUpdate, isLoading } = useMutation(promptUpdate);
  const { mutate: editSettings, isLoading: isEditSettingsLoading } =
    useMutation(updateSettings);

  const InitialPromptRequest = {
    id: response.settingsId!,
    input: "",
    isSettings: true,
  };

  const handleSuggestionClicked = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: number
  ) => {
    const clickedSuggestion = (e.target as HTMLDivElement).textContent;
    if (selectedSuggestionIndex === index) {
      searchForm.setFieldsValue({ "prompt-message": "" });
      setSelectedSuggestionIndex(-1);
    } else {
      searchForm.setFieldsValue({ "prompt-message": clickedSuggestion });
      setSelectedSuggestionIndex(index);
    }
  };
  const UpdateSearchSetting = () => {
    if (isLoading || isEditSettingsLoading) return;
    editSettings({ ...response, id: response.settingsId! } as ISearchPayload, {
      onSuccess: () => {
        promptSettingUpdate(
          {
            ...InitialPromptRequest,
            input: searchForm.getFieldValue("prompt-message"),
          },
          {
            onSuccess: (resp) => {
              setUser((prev) =>
                prev?.subscription
                  ? {
                      ...prev,
                      subscription: {
                        ...prev.subscription,
                        promptGridItemUpdateUsage:
                          prev.subscription.promptGridItemUpdateUsage - 1,
                      },
                    }
                  : prev
              );
              setResponse((prev) => ({
                ...prev,
                ...resp.data,
              }));
            },
          }
        );
      },
    });
  };

  return (
    <StyledContent>
      <StyledForm>
        <Form form={searchForm}>
          <Form.Item name="prompt-message">
            <Input
              placeholder="Enter a prompt and let the AI generate the updated chart"
              autoComplete="off"
              onPressEnter={UpdateSearchSetting}
              maxLength={255}
              suffix={
                isLoading || isEditSettingsLoading ? (
                  <LoadingOutlined color="#4974f6" />
                ) : (
                  <StyledIcon onClick={UpdateSearchSetting}>
                    <GalaxyStarIcon />
                  </StyledIcon>
                )
              }
            />
          </Form.Item>
        </Form>
      </StyledForm>
      <Suggestions>
        {response?.suggestion_question_settings?.map((suggestion, index) => {
          return (
            <Suggestion
              className={selectedSuggestionIndex === index ? "selected" : ""}
              onClick={(e) => handleSuggestionClicked(e, index)}
            >
              {suggestion}
            </Suggestion>
          );
        })}
      </Suggestions>
    </StyledContent>
  );
}

export default PromptMessages;

const StyledContent = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  // position: absolute;
  width: 84%;
  bottom: 0;
`;
const StyledForm = styled.div`
  .ant-input-affix-wrapper {
    border: none;
    border-radius: 30px;
    border-bottom: 2px solid #4974f6;
    background: #eff1fd;
    height: 40px;
    padding: 0px 11px 0px;
    box-shadow: none;
    font-size: 13px;
    .ant-input {
      background: transparent;
    }
    &:hover,
    &:focus {
      box-shadow: none !important;
    }
  }
`;
const Suggestions = styled.div`
  display: flex;
  gap: 10px;
  min-height: 36px;
  .selected {
    box-shadow: none;
    border: 2px solid #4974f6;
  }
`;
const Suggestion = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding: 8px 10px;
  border-radius: 20px;
  cursor: pointer;
  background: #eff1fd;
  border: 2px solid #eff1fd;
  font-size: 12px;
  height: 35px;
`;

const StyledIcon = styled.div`
  cursor: pointer;
  font-size: 20px;
  display: flex;
`;
